import styled from 'styled-components';
import palette from '@telus-uds/palette-allium/build/web/palette';

export const Heading = styled.p`
  padding: 5px 0;
  font-size: 24px;
  color: ${palette.color.purpleTelus};
`;

export const FieldWrapper = styled.div`
  margin: 1em 0;
`;

export const Text = styled.p`
  font-weight: ${props => (props.bold ? '600' : props.fontWeight || '400')};
  font-size: 16px;
  display: inline;
  letter-spacing: -0.2px;
  color: ${props => props.color};
`;

export const ModalBox = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 200px;
`;

export const customStyles = `
  overflow: scroll;
  max-height: 80% !important;
  height:83%;
  width: 67%;
  position: fixed;
  margin-left: 17%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;
  text-align: left;
  `;
export const InputWrapper = styled.div`
  input[type='text'] {
    height: 3rem;
    outline: 0;
    text-overflow: ellipsis;
    border-color: #54595f;
    background-color: #fff;
    padding: 0.5rem 3rem 0.5rem 1rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    word-wrap: break-word;
    font-size: 1rem;
    letter-spacing: -0.8px;
    line-height: 1.5;
    font-weight: 400;
    color: #2a2c2e;
    min-height: 3rem;
    max-height: 3rem;
    width: 100%;
    margin: 8px 0;

    :focus {
      box-shadow: rgb(84, 89, 95) 0 0 4px 1px;
      background-color: rgb(255, 255, 255);
      border-color: transparent;
    }
  }
  #basic-typeahead {
    max-height: 200px !important;
  }
`;

export const OrderHistoryMain = styled.div`
  padding: 1rem;
  margin-top: 2rem;
  border: 1px solid #d8d8d8;
`;

export const OrderHistoryDate = styled.div`
  font-size: 1.2em;
  font-weight: 700;
  margin: 0.5rem 0;
  border-bottom: 1px solid #d8d8d8;
  padding: 0.5rem 0;
`;

export const OrderHistoryDataMain = styled.div`
  display: flex;
  padding: 0.25rem 0;
`;

export const OrderHistoryTimestamp = styled.div`
  margin-right: 5rem;
  color: #71757b;
  font-size: 14px;
  font-weight: 700;
`;

export const OrderHistoryAction = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
